import { Controller } from '@hotwired/stimulus';

class RedirectController extends Controller {
  static targets = ['form']

  static values = {
    delay: { type: Number, default: 20000 }
  }

  connect() {
    this.timeout = setTimeout(() => this.submitForm(), this.delayValue)
  }

  manualSubmit(event) {
    event.preventDefault()
    this.submitForm()
  }

  submitForm() {
    if (this.formTarget) this.formTarget.submit()
  }
}

export default RedirectController;
